import React, { useState, useCallback, memo } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@material-ui/core';

import useStyles from './styles';

const HelpPageModal = ({ onClose, helpLink }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      onExited={onClose}
      PaperProps={{
        className: classes.container,
      }}
    >
      <DialogContent className="content">
        <iframe
          src={helpLink}
          className="iframe-help"
          title="Página de ajuda"
          mozallowfullscreen=""
          webkitallowfullscreen=""
          allowFullScreen=""
          allow-top-navigation=""
          allow-scripts=""
        />
      </DialogContent>
      <DialogActions>
        <Button className="close-button" onClick={handleClose}>
          FECHAR
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(HelpPageModal);
